/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Tooltip_Autosync_UnavailableInputs */

const es_settings_files_tooltip_autosync_unavailable = /** @type {(inputs: Settings_Files_Tooltip_Autosync_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No disponible para archivos locales`)
};

const en_settings_files_tooltip_autosync_unavailable = /** @type {(inputs: Settings_Files_Tooltip_Autosync_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not available for local files`)
};

/**
* | output |
* | --- |
* | "Not available for local files" |
*
* @param {Settings_Files_Tooltip_Autosync_UnavailableInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_tooltip_autosync_unavailable = /** @type {((inputs?: Settings_Files_Tooltip_Autosync_UnavailableInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Tooltip_Autosync_UnavailableInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_tooltip_autosync_unavailable(inputs)
	return en_settings_files_tooltip_autosync_unavailable(inputs)
});
export { settings_files_tooltip_autosync_unavailable as "settings.files.tooltip.autosync_unavailable" }